import React, { useState, useEffect } from 'react';
import { useHistory } from "react-router-dom";

import InputAdornment from '@material-ui/core/InputAdornment';
import TextField from '@material-ui/core/TextField';
import IconButton from '@material-ui/core/IconButton';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import CircularProgress from '@material-ui/core/CircularProgress';

import './styles.css';
import { AuthUserContext, withAuthorization } from '../../../contexts/Session';
import Header from '../../../components/Header/Admin/index';
import ConfirmationModal from '../../../components/Modal/Admin/ConfirmDelete/index';
import ActionModal from '../../../components/Modal/ActionModal/index';
// import api from '../../../services/api'

const ListProfiles = (props) => {

    const history = useHistory();
    const[mount, setMount] = useState(false);

    const[email, setEmail] = useState('');
    const[confirmNewEmail, setConfirmNewEmail] = useState('');
    const[newEmail, setNewEmail] = useState('');
    
    const[password, setPassword] = useState('');
    const[newPassword, setNewPassword] = useState('');
    const[confirmNewPassword, setConfirmNewPassword] = useState('');

    const[disableEmail, setDisableEmail] = useState(true);
    const[disablePassword, setDisablePassword] = useState(true);

    const[errorPassword, setErrorPassword] = useState(false);
    const[msgPassword, setMsgPassword] = useState('');

    const[errorConfirmPassword, setErrorConfirmPassword] = useState(false);
    const[msgConfirmPassword, setMsgConfirmPassword] = useState('');
    
    const[errorEmail, setErrorEmail] = useState(false);
    const[msgEmail] = useState('');

    const[errorNewEmail, setErrorNewEmail] = useState(false);
    const[msgNewEmail, setMsgNewEmail] = useState('');

    const[errorConfirmEmail, setErrorConfirmEmail] = useState(false);
    const[msgConfirmEmail, setMsgConfirmEmail] = useState('');

    const[showPassword, setShowPassword] = useState(false);
    const[showNewPassword, setShowNewPassword] = useState(false)
    const[showConfirmPassword, setShowConfirmPassword] = useState(false);
    const[showProgress, setShowProgress] = useState(false);

    const[textModal, setTextModal] = useState('');
    const[showModal, setShowModal] = useState(false);

    const[showModalAction, setShowModalAction] = useState(false);
    const[textAction, setTextAction] = useState('');
    const[titleAction, setTitleAction] = useState('');
    const[actionProgress, setActionProgress] = useState(false);

    const[actionFunction, setActionFunction] = useState('');

    useEffect(() => {
        if(!mount){
            props.firebase.auth.currentUser.getIdTokenResult()
                .then((idTokenResult) => {
                    setEmail(idTokenResult.claims.email);
                    setMount(true);
                    console.log('object');
                })
                .catch((error) => {
                    console.log(error);
                })
        }
    })

    const handleConfirm = () =>{
        setShowProgress(false);

        if(!disableEmail){
            console.log('emailll');
            setActionFunction(()=>handleUpdateEmail);
            setTitleAction('Confirmar mudança de email?');
            setShowModalAction(true);//shows the confirmation modal

        }else if(!disablePassword){
            console.log('passss');

            setActionFunction(()=>handleUpdatePassword);
            setTitleAction('Confirmar mudança de senha?');
            setShowModalAction(true)//shows the confirmation modal
        }
    }

    const handleUpdateEmail = () => {
        
        
        if(newEmail === ''){
            setErrorNewEmail(true);
            setMsgNewEmail('Você deve inserir um email');
        }

        if (newEmail !== confirmNewEmail) {
            setErrorConfirmEmail(true);
            setMsgConfirmEmail('Os emails devem ser iguais');
        }else {
        
            props.firebase
                .doReauthenticateWithCredential(confirmNewPassword).then( () => {
                    props.firebase
                        .doEmailUpdate(newEmail)
                        .then(() => {
                            setDisableEmail(true);
                            setDisablePassword(true);
                            setTextModal('Email alterado com sucesso!');//success modal message
                            setShowModal(true);//shows success modal
                            setMount(!mount);
                        })
                        .catch(error => {
                            // console.log(error)
                            emailError(error);//sets email message error
                        });
                })
                .catch((err) => {
                    console.log(err);
                    setErrorConfirmPassword(true);
                    setMsgConfirmPassword('Senha invalida');
                    setShowProgress(false);
                });
        }
            setShowProgress(false)//stops the progress circle
    }

    const emailError = (error) =>{
        setShowProgress(false)

        if(error.message === 'The email address is badly formatted.'){
            setErrorNewEmail(true);
            setMsgNewEmail('Formato inválido');
        }else if(error.message === 'The email address is already in use by another account.'){
            setShowModal(true);
            setTextModal('Outra conta está utilizando esse email!');
        }else if(error.message === 'This operation is sensitive and requires recent authentication. Log in again before retrying this request.'){
            setTextModal('A alteração de email exige um login recente. Portanto, realize o login novamente');
            setShowModal(true);
        }
    }

    const handleUpdatePassword = async() =>{

        if(newPassword.length < 6){
            setErrorPassword(true);
            setMsgPassword('A senha deve conter mais de 6 dígitos');
            setShowProgress(false);
            return;
        } 
        
        if (newPassword !== confirmNewPassword) {
            setErrorPassword(true);
            setMsgPassword('As senhas devem ser iguais');
            setShowProgress(false);
            
            setErrorConfirmPassword(true);
            setMsgConfirmPassword('As senhas devem ser iguais');
            setShowProgress(false);
            return;
        }

        props.firebase
            .doReauthenticateWithCredential(password).then( () => {
                props.firebase
                .doPasswordUpdate(newPassword)
                .then(() => {
                    setDisablePassword(true);
                    setDisableEmail(true);
                    setShowProgress(false);
                    setPassword('');
                    setTextModal('Senha alterada com sucesso!');
                    setShowModal(true);
                })
                .catch(error => {
                    // console.log(error)
                    passwordError(error);
                })
            })
            .catch((err) => {
                console.log(err);
                setErrorConfirmPassword(true);
                setMsgConfirmPassword('Senha invalida');
                setShowProgress(false);
            });
        setShowProgress(false)//stops the progress circle
    }

    const passwordError = (error) =>{
        setShowProgress(false)

        if(error.message === 'This operation is sensitive and requires recent authentication. Log in again before retrying this request.'){
            setTextModal('A alteração de senha exige um login recente. Portanto, realize o login novamente');
            setShowModal(true);
        }else {
            setTextModal('Erro ao alterar senha!');
            setShowModal(true);
        }
    }

    const handleDeleteAccount = () =>{
        setActionFunction(()=>handleDelete);
        setTitleAction('Confirmar exclusão da conta?');
        setTextAction('Essa ação é irreversível!');
        setShowModalAction(true)
    }

    const handleDelete = () =>{
        props.firebase.doDeleteUser()
    }
  
    return(
        <div className='updateProfileContainer'>
            <AuthUserContext.Consumer> 
            {authUser =>
                authUser ? 
                    <div>
                        <Header/>
                        <div className='container-management2'> 
                            <h1 className='page-title-adm'> Perfil</h1>
                            <br/>

                            {disablePassword ? 
                                <TextField id="email-input" 
                                    label={errorEmail? msgEmail :"Email"}
                                    size = "small" 
                                    variant="outlined"
                                    className="search-input"
                                    error={errorEmail}
                                    disabled={disableEmail}
                                    value ={email} 
                                    onChange={event => {
                                        setEmail(event.target.value)
                                        setErrorEmail(false)
                                    }}
                                /> 
                            : null}

                            { !disableEmail? 
                                <>
                                    <TextField id="email-input" 
                                        label={errorConfirmEmail? msgNewEmail :"Insira o novo Email"}
                                        size = "small" 
                                        variant="outlined"
                                        className="search-input"
                                        error={errorNewEmail}
                                        disabled={disableEmail}
                                        value ={newEmail} 
                                        onChange={event => {
                                            setNewEmail(event.target.value)
                                            setErrorNewEmail(false)
                                        }}
                                    /> 

                                    <TextField id="email-input" 
                                        label={errorConfirmEmail? msgConfirmEmail :"Confirme o novo Email"}
                                        size = "small" 
                                        variant="outlined"
                                        className="search-input"
                                        error={errorConfirmEmail}
                                        disabled={disableEmail}
                                        value ={confirmNewEmail} 
                                        onChange={event => {
                                            setConfirmNewEmail(event.target.value)
                                            setErrorConfirmEmail(false)
                                        }}
                                    /> 

                                    <TextField
                                        className='search-input' 
                                        id="input-confirm-password"
                                        label={errorConfirmPassword ? msgConfirmPassword:'Confirma a senha'}
                                        type={showConfirmPassword ? 'text' : 'password'}
                                        size = "small" 
                                        value={confirmNewPassword}
                                        disabled={disableEmail}
                                        variant="outlined"
                                        error={errorConfirmPassword}
                                        InputProps={{
                                            endAdornment:(
                                                <InputAdornment position="end">
                                                    <IconButton
                                                        aria-label="toggle password visibility"
                                                        onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                                        onMouseDown={event => event.preventDefault()}
                                                        edge="end"
                                                    >
                                                    {showConfirmPassword ? <Visibility /> : <VisibilityOff />}
                                                    </IconButton>
                                                </InputAdornment>
                                            ),
                                        }}
                                        onChange={event => {
                                            setConfirmNewPassword(event.target.value)
                                            setErrorPassword(false)
                                        }}
                                    />  
                                </>
                            : null}

                            <br/>
                            { !disablePassword? 
                                <>

                                    <TextField
                                        className='search-input' 
                                        id="input-password"
                                        label={errorPassword ? msgPassword:'Confirme a senha atual'}
                                        type={showPassword ? 'text' : 'password'}
                                        size = "small" 
                                        value={password}
                                        disabled={disablePassword}
                                        variant="outlined"
                                        error={errorPassword}
                                        InputProps={{
                                            endAdornment:(
                                                <InputAdornment position="end">
                                                    <IconButton
                                                        aria-label="toggle password visibility"
                                                        onClick={() => setShowPassword(!showPassword)}
                                                        onMouseDown={event => event.preventDefault()}
                                                        edge="end"
                                                    >
                                                    {showPassword ? <Visibility /> : <VisibilityOff />}
                                                    </IconButton>
                                                </InputAdornment>
                                            ),
                                        }}
                                        onChange={event => {
                                            setPassword(event.target.value)
                                            setErrorPassword(false)
                                        }}
                                    />  

                                    <TextField
                                        className='search-input' 
                                        id="input-new-password"
                                        label={errorPassword ? msgPassword:'Insira a nova senha'}
                                        type={showNewPassword ? 'text' : 'password'}
                                        size = "small" 
                                        value={newPassword}
                                        disabled={disablePassword}
                                        variant="outlined"
                                        error={errorPassword}
                                        InputProps={{
                                            endAdornment:(
                                                <InputAdornment position="end">
                                                    <IconButton
                                                        aria-label="toggle password visibility"
                                                        onClick={() => setShowNewPassword(!showNewPassword)}
                                                        onMouseDown={event => event.preventDefault()}
                                                        edge="end"
                                                    >
                                                    {showNewPassword ? <Visibility /> : <VisibilityOff />}
                                                    </IconButton>
                                                </InputAdornment>
                                            ),
                                        }}
                                        onChange={event => {
                                            setNewPassword(event.target.value);
                                            setErrorPassword(false);
                                        }}
                                    /> 

                                    <TextField
                                        className='search-input' 
                                        id="input-confirm-new-password"
                                        label={errorConfirmPassword ? msgConfirmPassword:'Confirme a nova senha'}
                                        type={showConfirmPassword ? 'text' : 'password'}
                                        size = "small" 
                                        value={confirmNewPassword}
                                        disabled={disablePassword}
                                        variant="outlined"
                                        error={errorConfirmPassword}
                                        InputProps={{
                                            endAdornment:(
                                                <InputAdornment position="end">
                                                    <IconButton
                                                        aria-label="toggle password visibility"
                                                        onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                                        onMouseDown={event => event.preventDefault()}
                                                        edge="end"
                                                    >
                                                    {showConfirmPassword ? <Visibility /> : <VisibilityOff />}
                                                    </IconButton>
                                                </InputAdornment>
                                            ),
                                        }}
                                        onChange={event => {
                                            setConfirmNewPassword(event.target.value);
                                            setErrorPassword(false);
                                        }}
                                    />
                                    
                                </>
                            : null}

                            {disableEmail && disablePassword ? 
                            <>
                                <button 
                                    id='atualizar-email-button' 
                                    className='button-adm-cng'
                                    onClick={e=>setDisableEmail(false)}
                                >Atualizar email</button> 

                                <button 
                                    id='atualizar-senha-button' 
                                    className='button-adm-cng'
                                    onClick={e=>setDisablePassword(false)}
                                >Atualizar senha</button>

                                <button 
                                    id='excluir-conta-button' 
                                    className='button-adm-cng-excl'
                                    onClick={handleDeleteAccount}
                                >Excluir conta</button>
                            </> : 
                            
                            <><br/>
                                <button 
                                    className='modal-confirm-buttons1 btn-cnf' 
                                    onClick={handleConfirm}
                                    disabled={showProgress}
                                >
                                    { showProgress ? <CircularProgress color='primary' size={15} /> :'Confirmar'}
                                </button>
                                <button 
                                    id='atualizar-senha-button' 
                                    className='button-adm-cng'
                                    onClick={e=>{
                                        setDisableEmail(true);
                                        setDisablePassword(true);
                                        setShowProgress(false)
                                        setErrorPassword(false)
                                    }}
                                >Cancelar</button>
                            </>
                            }
                        </div>
                        <ConfirmationModal
                            text={textModal}
                            setShow={setShowModal}
                            showModal={showModal}
                        />
                        <ActionModal //asks if the user declines or accepts
                            showModal={showModalAction}
                            decline={setShowModalAction}
                            action={actionFunction}
                            title={titleAction}
                            text={textAction}
                            showProgress={actionProgress}
                            setShowProgress={setActionProgress}
                        />
                        <br/><br/>

                    </div>

            : 
                history.push('/')
            }
            </AuthUserContext.Consumer>
        </div>
    )
}

const condition = authUser => !!authUser;

export default withAuthorization(condition)(ListProfiles);